/**
 * Created by 不动的推动者 on 2018/5/2.
 */
import {
  COLLAPSE,
  COMPANY,
  SET_COMPANY,
  VERIFY_STATUS,
  LOGIN,
  LOGOUT,
}from './mutation-type'

export default {
  login({ commit }, payload) {
      localStorage.setItem('token', payload.token);
      localStorage.setItem('userId', payload.user.id);
      localStorage.setItem('userName', payload.user.username);
      localStorage.setItem('cnName', payload.user.cn_name);
      localStorage.setItem('phone', payload.user.phone);
      localStorage.setItem('companyId', payload.user.company_id);
      localStorage.setItem('default_url', payload.user.default_url);
      localStorage.setItem('companyValue', payload.user.company_id);
      commit(LOGIN);
  },
  logout({ commit }) {
      localStorage.clear();
      commit(LOGOUT);
  },
  setCompany({ commit }, companyValue) {
      localStorage.setItem('companyValue', companyValue);
      commit(SET_COMPANY, companyValue);
  },
  getCollapse({commit}){
    commit('COLLAPSE');
  },
  getVerifyStatus({commit},verifyStatus){ //获取
    commit('VERIFY_STATUS',verifyStatus)
  },
  storeOrderListUUid({commit},orderListInfo){ //存储
    commit('ORDER_LIST_INFO',orderListInfo)
  },
  dialogFromAudit({commit}){ //批量审核
    commit('DIALOG_FROM_AUDIT')
  },
  dialogFromUnAudit({commit}){ //批量反深恶黑
    commit('DIALOG_FROM_UN_AUDIT')
  },
  dialogFromDifferences({commit}){ //批量差异对帐
    commit('DIALOG_FROM_DIFFERENCES')
  },
  dialogFromDelete({commit}){ //批量删除
    commit('DIALOG_FROM_DELETE')
  },
  dialogFromStatement({commit}){//报表通用弹出层
    commit('DIALOG_FROM_STATEMENT')
  },
  dialoggetWebSocket({commit}){//websocket
    commit('DIALOGGET_WEB_SOCKET')
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/actions.js